import React, { createContext, useState } from 'react';
import GeneralTemplate from '../templates/GeneralTemplate';
import cover from '../assets/cover/contact_us.jpg';
import RequestForm from '../components/RequestForm.js'
import WishingWall from '../components/WishingWall.js'

const ContactUs = () => {
  const bannerProps = {
    imageSrc: cover,
    title: "聯絡我們",
    subtitle: (
    <>
      <p className="subtitle">請留下您的寶貴回饋，我們將會盡快回覆。<br/>也歡迎分享您希望新增的功能，就有機會在未來推出</p>
      <p>Please leave your valuable feedback, and we will reply to you as soon as possible.<br/>Also, feel free to share any features you would like us to add; we will carefully evaluate your suggestions.</p>
    </>)
  };

  const content = (
    <div>
      <RequestForm/>
      <WishingWall/>
    </div>
  );

  return (

    <GeneralTemplate 
      bannerProps={bannerProps} 
      content={content} 
    />
  );
}

export default ContactUs;